/**
 * vuex mutation types
 *
 */

// 设置tokenName
export const SET_TOKEN_NAME = "SET_TOKEN_NAME";

// 设置token
export const SET_TOKEN = "SET_TOKEN";

// 设置语言
export const SET_LANG = "SET_LANG";

// 设置用户信息
export const SET_USER_INFO = "SET_USER_INFO";

// 设置用户id
export const SET_USER_ID = "SET_USER_ID";

// 设置个人tag
export const SET_USER_TAGS = "SET_USER_TAGS";

// 设置消息未读数
export const SET_UNREAD_COUNT = "SET_UNREAD_COUNT";

// 设置系统消息未读数
export const SET_SYSTEM_UNREAD_COUNT = "SET_SYSTEM_UNREAD_COUNT";

// 设置客服消息未读数
export const SET_CUSTOMER_UNREAD_COUNT = "SET_CUSTOMER_UNREAD_COUNT";

// 设置GROUP消息未读数
export const SET_GROUPS_UNREAD_TOTAL_COUNT = "SET_GROUPS_UNREAD_TOTAL_COUNT";

// 设置左侧菜单栏打开关闭
export const SET_COLLAPSE = "SET_COLLAPSE";

// 设置右侧tabs可关闭顶栏
export const SET_EDITABLE_TABS = "SET_EDITABLE_TABS";

// 设置右侧tabs默认选中值
export const SET_EDITABLE_TABS_VALUE = "SET_EDITABLE_TABS_VALUE";

// 设置菜单
export const SET_MENULISTS = "SET_MENULISTS";
